import Immutable from "seamless-immutable";
import {
  GET_DELIVERY_ENABLED_SUCCESS,
  GET_DELIVERY_ENABLED_FAILURE,
  GET_COMMON_CONFIG_SUCCESS,
  GET_COMMON_CONFIG_FAILURE,
  GET_OCCUPATION_REQUEST,
  GET_OCCUPATION_SUCCESS,
  GET_OCCUPATION_FAILURE
} from "../actions/common";

const INITIAL_STATE = Immutable({
  config: null
});

function common(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_DELIVERY_ENABLED_SUCCESS:
      return state.setIn(["config"], action.data);
    case GET_DELIVERY_ENABLED_FAILURE:
      return state.setIn(["config"], false);
    case GET_COMMON_CONFIG_SUCCESS:
      return state.setIn(["config"], action.data);
    case GET_COMMON_CONFIG_FAILURE:
      return state.setIn(["config"], false);
    case GET_OCCUPATION_REQUEST:
      return state.setIn(["updateLoading"], true).setIn(["item"], action.data);
    case GET_OCCUPATION_SUCCESS:
      return state.setIn(["updateLoading"], false).setIn(["item"], action.data);
    case GET_OCCUPATION_FAILURE:
      return state.setIn(["updateLoading"], false).setIn(["item"], false);
    default:
      return state;
  }
}

export default common;



// WEBPACK FOOTER //
// ./src/reducers/common.js